/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

import { formatDollarsStandard } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Formats a dollar amount using formatDollarsStandard(). For example, given the input `1001`, the
 * output would be '$1,001.00'.
 */
export function DollarsCellStandard<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const { value } = cell;

    return (
        <div className="flex justify-end">
            <span>
                {typeof value === 'string'
                    ? value
                    : formatDollarsStandard(value)}
            </span>
        </div>
    );
}
